<template>
	<EventTagEdit
		:elapsed="elapsed"
	/>
</template>

<script>
import EventTagEdit from '@js/analysis/components/EventTagEdit/EventTagEdit';

export default {
	name:       'TagDetailsBlock',
	components: { EventTagEdit },
	props:      {
		elapsed: {
			type:    Number,
			default: 0,
		},
	},
	data() {
		return {};
	},
	methods: {
	},
};
</script>

<style lang="scss" scoped></style>
